export const getTopBetServiceTitle = (currentPrice: number, topPrice: number): string =>
  currentPrice > topPrice ? 'Топ + Ставка' : 'Топ';
